import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  Heading18,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import {
  spacing12,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { Box, BoxList } from 'approot/shared/design-system/box/box.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const InteractiveResponseCategories = styled.div`
  display: flex;
  gap: ${rem(spacing16)};
  padding: 0 ${rem(spacing24)};
  flex-grow: 1;
`;

export const InteractiveResponseCategory = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const InteractiveResponseCategoryRow = styled.div`
  ${flexCentreAlignCss}
  gap: ${rem(spacing16)};
  flex-wrap: wrap;
`;

export const InteractiveResponseCategoryLabel = styled(Heading18).attrs({
  as: 'h2',
  marginBottom: spacing12,
})`
  font-weight: ${fontWeightMedium};
  text-align: center;
`;

export const InteractiveResponseCategoryContainer = styled(BoxList)`
  ${flexCentreAlignCss}

  flex-wrap: wrap;
  gap: ${rem(spacing16)};
  margin: auto;
  min-height: ${rem(140)};
  padding: ${rem(spacing24)} 0 0 0;
  position: relative;
  width: 100%;
`;

export const InteractiveResponseCategoryContainerItem = styled.li``;

export const InteractiveResponseCategoryFreeCheckWrapper = styled(Box).attrs({
  $marginBottom: 24,
  $gap: 4,
  $alignItems: 'center',
  $justifyContent: 'center',
})`
  width: 100%;
`;
